<template>
    <div class="two-house-area pt-100 pb-70" id="aboutus">
        <div class="container">
            <div class="row">

                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-shopping-bag'></i>
                        </div>
                        <h3>{{ $t('about.card1.title') }}</h3>
                        <p>
                            {{ $t('about.card1.desc') }}
                        </p>
                        <a href="https://wa.me/34634061655?text=Hola,%20quiero%20información%20sobre%20vuestros%20servicios" target="_blank" rel="noopener">
                            {{ $t('about.cta') }}
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-dollar-circle'></i>
                        </div>
                        <h3>{{ $t('about.card2.title') }}</h3>
                        <p>
                            {{ $t('about.card2.desc') }}
                        </p>
                        <a href="https://wa.me/34634061655?text=Hola,%20quiero%20información%20sobre%20vuestros%20servicios" target="_blank" rel="noopener">
                            {{ $t('about.cta') }}
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>

                <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-globe'></i>
                        </div>
                        <h3>{{ $t('about.card3.title') }}</h3>
                        <p>
                            {{ $t('about.card3.desc') }}
                        </p>
                        <a href="https://wa.me/34634061655?text=Hola,%20quiero%20asesoramiento%20para%20mi%20negocio" target="_blank" rel="noopener">
                            {{ $t('about.cta') }}
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>